import { useEffect, useState } from 'react';

import useLocationState from './useLocationState';

interface LocationState {
  isError?: boolean;
  message?: string;
  title?: string;
}

function useGetAlertFromLocationState() {
  const locationState = useLocationState<LocationState>();

  const [message, setMessage] = useState<string | undefined>(undefined);
  const [title, setTitle] = useState<string | undefined>(undefined);
  const [isError, setIsError] = useState(false);
  const [displayAlert, setDisplayAlert] = useState(false);

  useEffect(() => {
    if (locationState !== null && locationState.isError) {
      setDisplayAlert(true);
      setMessage(locationState.message);
      setTitle(locationState.title);
      setIsError(locationState.isError);
    } else {
      setDisplayAlert(false);
    }
  }, [locationState]);

  return {
    message,
    title,
    isError,
    displayAlert,
  };
}

export default useGetAlertFromLocationState;
